<template>
<div class="px-10">

      <div class="row no-gutter" style="background-color:#500a96;">
        <div class="col-12"><img src="https://dellpartnerincentives.com/siteassets/Images/DNCP/head.jpg" alt="Unbeatable value, every time!" border="0" style="width:100%;display:flex;"></div>
      </div>


      <div class="row no-gutter" style="background-color:#1d56c0;padding:30px 0px;">
        <div class="col-11">
          <div class="px-10 tx-color-white">
            <H1 class="mx-12 pb-2">Boost your sales. Elevate every deal.</H1>
            <p class="tx-font-normal mx-12">Now's the time to power up your profits—with up to 30% off Dell Displays and Client Peripherals. From highperformance
              monitors and docks to premium headsets and keyboards, these productivity essentials are engineered
              to enhance every workspace.</p>
            <p class="tx-font-normal mx-12">As a valued RISE Incentive Program partner, your success earns you more—more rewards, more recognition,
              more growth.</p>
          </div>
        </div>
      </div>
      
      <div class="row no-gutter" style="background-color:#1d56c0;padding:0px 0px 0px 0px;">
        <div class="col-10">
          <div style="padding:0px;">
            <div class="d-flex justify-start">
              <v-row>
                <v-col cols="6">
                  <div  class="ps-16" style="padding:44px 24px 44px 44px;background-color:#80c7fb;min-height:115px;color:#1d56c0;">
                   <div  class="ps-6">
                    <a href="https://dellpartnerincentives.com/resources/DnCP%20Promotions.pdf" target="_blank">View</a> the full range of Dell Displays and Client Peripherals promotions.
                   </div>
                  </div>
                </v-col>
                <v-col cols="4" class="ms-n10">     
                  <img src="https://dellpartnerincentives.com/siteassets/Images/DNCP/content.png" style="width:100%;max-width:356px;vertical-align: middle;">             
                </v-col>
                <v-col cols="2"></v-col>   
              </v-row>

            </div>
          </div>    
        </div>
      </div>

      <div class="row no-gutter" style="background-color:#1d56c0;">
        <div class="col-12">
          <div style="padding:14px 100px 14px 75px;">
          <p style="font-size:90%;text-align:start;color:#ffffff;" class="tx-font-bold tx-font-size24 pa-5 ps-4"><strong>Available in:</strong> United Kingdom, France, Germany, Ireland, Spain, Italy, Portugal, Belgium, Netherlands, Sweden, Denmark, Finland,
          Norway, Austria and Switzerland.</p>
          </div>
        </div>
      </div>        


      
      <div class="row no-gutter" style="background-color:#00227f;">
        <div class="col-2">&nbsp;

        </div>
        <div class="col-8">
          <div class="tx-color-white tx-font-size10 tx-font-thin ps-10">
            <div class="tx-color-white ps-13">
              Copyright © 2025 Dell Inc. or its subsidiaries. All Rights Reserved. Dell Technologies, Dell, 
          and other trademarks are trademarks of Dell Inc. or its subsidiaries. Other trademarks may be trademarks of their respective owners.
             </div>
          </div>
        </div>
        <div class="col-2">&nbsp;</div>
      </div>

</div>


</template>

<script setup>

</script>

<style scoped>

</style>